import React from 'react';
import {
  TokenLogoMap,
  NetworkLogoMap,
  getTokenHumanReadableNameByChain,
} from 'features/bill/lib';
import { toast } from 'react-toastify';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';

export const PaymentInformation: React.FC<{
  title?: string;
  walletAddress: string;
  network: string;
  token: string;
  amount: string;
  balance?: string;
  usdValue?: string;
  showRecipientLabel?: boolean;
  recipientLabel?: string;
}> = ({
  title = 'Payment Information',
  walletAddress,
  network,
  token,
  amount,
  balance,
  usdValue,
  showRecipientLabel = true,
  recipientLabel,
}) => {
  return (
    <div>
      <h3 className="mb-5 text-base font-semibold leading-6 text-slate-400">
        {title}
      </h3>

      {/* Payment Details */}
      <div className="mt-2">
        <div className="flex flex-col items-start">
          {showRecipientLabel && (
            <div className="text-xs font-normal text-slate-400">
              {recipientLabel || 'Recipient'}
            </div>
          )}
          <div className="flex w-[100%] items-center justify-between mt-1 mb-1 text-left text-sm font-medium text-slate-300">
            {walletAddress}
            <button
              type="button"
              className="ml-1 text-slate-400"
              onClick={() => {
                navigator.clipboard.writeText(walletAddress);
                toast.success('Copied to clipboard!');
              }}>
              <ClipboardDocumentIcon className="w-4" aria-hidden="true" />
            </button>
          </div>
          <div className="flex items-center text-xs text-slate-400">
            <div className="mr-1 h-4 w-4">
              <img src={NetworkLogoMap[network]} alt="" aria-hidden="true" />
            </div>
            {network}
          </div>
        </div>

        <div className="mt-4 flex flex-col">
          <div className="mb-1 flex items-end justify-between">
            <div>
              <div className=" text-left text-xs font-normal text-slate-400">
                Token
              </div>

              <div className="mt-1 flex items-center justify-between text-xs text-slate-400">
                <div className="mr-1 h-4 w-4">
                  <img src={TokenLogoMap[token]} alt="" aria-hidden="true" />
                </div>
                <div className=" text-sm font-medium text-slate-300">
                  {getTokenHumanReadableNameByChain(token, network)}
                </div>
              </div>
            </div>
            <div className="text-sm font-medium text-slate-300">{amount}</div>
          </div>

          {balance && (
            <div className="flex items-start justify-between">
              <div className="text-xs font-normal text-slate-400">
                Balance: {parseFloat(balance).toFixed(4)}
              </div>
              {!!usdValue && (
                <div className="text-xs font-normal text-slate-400">
                  ${usdValue}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="my-4 border-b border-slate-700"></div>
    </div>
  );
};
